module.exports = __webpack_public_path__ + "images/emoji/revolving_hearts.f5e47ad6a660cec0a241.png";